import { isEqual } from "lodash";
import { useEffect, useState } from "react";

export const useDatesAttachments = ({
  athleteSwitch,
  changedTemplate,
  datesAttachments,
  setReloading,
}) => {
  const [phasesAttachments, setPhasesAttachments] = useState(datesAttachments);

  // This updates the state when changing through athletes or when changing the phases templates
  // This fixes the issue for the checkboxes not updating
  useEffect(() => {
    (athleteSwitch || changedTemplate) &&
      datesAttachments &&
      !isEqual(datesAttachments, phasesAttachments) &&
      setPhasesAttachments(datesAttachments);
    setReloading(false);
  }, [datesAttachments]);

  return {
    phasesAttachments,
    setPhasesAttachments,
  };
};
